<template>
    <div>
        <el-row :inline="true">
            <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
                <el-tooltip class="item" effect="dark" content="返回上一级页面" placement="bottom-start" :disabled="showTooltip">
                    <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
                </el-tooltip>
            </el-col>
            <el-col :span="12">
                <h4 :inline="true">
                    <span ref="einvoiceTypeText" style="display:inline">
                        <!-- <font>开票</font> -->
                    </span>
                    <span ref="einvoiceTypeSelect" style="display:none; width:200px;">
                        <el-select id="einvoiceTypeSelect" v-model="einvoiceTypeCode" placeholder="请选择" @blur="changeText" @change="changeText">
                            <el-option v-for="item in einvoiceTypeOptions" :key="item.einvoiceTypeName" :label="item.einvoiceTypeName" :value="item.einvoiceTypeCode" >
                            </el-option>
                        </el-select>
                    </span>
                    <span style="display:inline; margin-left:10px;">
                        <i class="el-icon-edit"  @click="changeType" style="cursor: pointer"></i>
                    </span>
                </h4>
            </el-col>
            <el-col :span="10" style="padding-top: 19px; padding-left:130px;">
                <el-button type="primary" size="small" icon="el-icon-check" @click="saveEinv">开票</el-button>
           <!-- <el-button type="primary" size="small" icon="el-icon-printer" @click="saveEinv">保存并打印</el-button> --> 
                <el-button type="primary" size="small" icon="el-icon-close" @click="onBack">关闭</el-button>
            </el-col>
        </el-row>
        <div style="margin: 8px 40px 40px; border-bottom: 1px solid #CCC;">
            <el-form ref="form" :model="form" :rules="formRules" label-width="180px" v-loading="showLoading">
                <el-tabs id="tab1" v-model="activeName" @tab-click="handleClick"  type="border-card" :style="{height: tabHeight}">
                    <el-tab-pane label="基本信息" name="first">
                            <el-row style="margin-top:-10px">
                                <el-col :span="8" style="margin-left:-80px">
                                    <el-form-item label="交款人" required prop="payerPartyName">
                                        <el-input ref="ipt01" v-model="form.payerPartyName" placeholder="请输入交款人" maxlength="100"
                                            show-word-limit margin-top:-80px style="width:200px" ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="交款人类型" required prop="payerPartyType">
                                        <el-select v-model="form.payerPartyType" placeholder="请选择" style="width:200px">
                                            <el-option v-for="item in einvoiceJkrlxOptions" :key="item.value" :label="item.value" :value="item.key" >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="交款方式" required prop="payMode">
                                        <el-select v-model="form.payMode" placeholder="请选择" style="width:200px">
                                            <el-option v-for="item in einvoiceSkfsOptions" :key="item.value" :label="item.value" :value="item.key" >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row  style="margin-top:-10px">
                                <el-col :span="8" style="margin-left:-80px">
                                    <el-form-item label="交款人代码" prop="payerPartyCode">
                                        <el-input ref="ipt01" v-model="form.payerPartyCode" placeholder="请输入交款人代码" maxlength="30"
                                            show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="手机号" prop="tel">
                                        <el-input ref="ipt01" v-model="form.tel" placeholder="请输入手机号" maxlength="100"
                                            show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="邮箱" prop="email">
                                        <el-input ref="ipt01" v-model="form.email" placeholder="请输入邮箱" maxlength="100"
                                            show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                    </el-form-item>
                                </el-col>
                                <!-- <el-col :span="8">
                                    <el-form-item label="校验码" required prop="placeCode">
                                        <el-input ref="ipt01" v-model="form.placeCode" placeholder="请输入开票点代码" maxlength="20"
                                            show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                    </el-form-item>
                                </el-col> -->
                            </el-row>
                            <el-row  style="margin-top:-10px">
                                <el-col :span="24" style="margin-left:-80px">
                                    <el-form-item label="备注" prop="bz">
                                        <el-input ref="ipt01" v-model="form.bz" placeholder="请输入备注" maxlength="500"
                                            show-word-limit margin-top:-80px  style="width:840px"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-table ref="singleTable" :data="form.recordData" highlight-current-row :row-style="{height:'25px'}" style="min-height:550px;" :height="tableHeight"
                                :header-cell-style="{background:'#F5F7FA',color:'#606266'}" :summary-method="getSummaries" show-summary>
                                <el-table-column property="displaySeq" type="index" width="50" label="行号"></el-table-column>
                                <el-table-column property="auxItemCode" label="项目编码" >
                                    <template slot-scope="scope">
                                        <el-input :id="scope.$index" size="small" v-model="scope.row.auxItemCode" controls-position="right" margin-top:-80px maxlength="20"
                                            @blur="handleInputBlur" @focus="handleInputFocus" v-on:input ="handleEdit"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column property="auxItemName" label="项目名称">
                                    <template slot-scope="scope">
                                        <el-input :id="scope.$index" size="small" v-model="scope.row.auxItemName" controls-position="right" margin-top:-80px maxlength="20" 
                                            @blur="handleInputBlur" @focus="handleInputFocus" v-on:input ="handleEdit"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column property="auxItemUnit" label="单位">
                                    <template slot-scope="scope">
                                        <el-input size="small" v-model="scope.row.auxItemUnit" controls-position="center" margin-top:-80px maxlength="20"  readonly="readonly"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column property="auxItemQuantity" label="数量">
                                    <template slot-scope="scope">
                                        <el-input :id="scope.$index" size="small" v-model="scope.row.auxItemQuantity" controls-position="left" margin-top:-80px maxlength="30"  @focus="handleInputFocus" v-on:input ="changeAmount" onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column property="auxItemStd" label="标准">
                                    <template slot-scope="scope">
                                        <el-input size="small" v-model="scope.row.auxItemStd" controls-position="right" margin-top:-80px maxlength="20"  readonly="readonly"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column property="auxItemAmount" label="金额">
                                    <template slot-scope="scope">
                                        <el-input :id="scope.$index" size="small" v-model="scope.row.auxItemAmount" controls-position="left" margin-top:-80px maxlength="19" v-on:input ="checkAuxItemAmount" @focus="handleInputFocus" onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column property="createTime" :render-header="renderHeader" width="80">
                                    <template slot-scope="scope">
                                        <el-button size="mini" @click="onRemove(scope.row,scope.$index)" class="el-icon-delete"></el-button>
                                    </template>                              
                                </el-table-column>
                            </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="扩展信息" name="second" v-if="kzxxFlag">
                            <div id="medicalDiv">
                                <el-row style="margin-top:-10px">
                                    <el-col :span="8" style="margin-left:-70px">
                                        <el-form-item label="医疗类别" prop="medicalType">
                                            <el-input ref="ipt01" v-model="form.medicalType" placeholder="请输入医疗类别" maxlength="20"
                                                show-word-limit margin-top:-80px style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="门诊号" prop="patientNumber">
                                            <el-input ref="ipt01" v-model="form.patientNumber" placeholder="请输入门诊号" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="就诊日期" prop="medicalDate">
                                            <el-date-picker placeholder="选择就诊日期" v-model="form.medicalDate" style="width:200px" 
                                                value-format="yyyy-MM-dd" ></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:-10px">
                                    <el-col :span="8" style="margin-left:-70px">
                                        <el-form-item label="医疗机构类型" prop="orgType">
                                            <el-input ref="ipt01" v-model="form.orgType" placeholder="请输入医疗机构类型" maxlength="20"
                                                show-word-limit margin-top:-80px style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="医保类型" prop="medicalInsuranceType">
                                            <el-input ref="ipt01" v-model="form.medicalInsuranceType" placeholder="请输入医保类型" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="医保编号" prop="medicalInsuranceId">
                                            <el-input ref="ipt01" v-model="form.medicalInsuranceId" placeholder="请输入医保编号" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:-10px">
                                    <el-col :span="8" style="margin-left:-70px">
                                        <el-form-item label="医保统筹基金支付" prop="fundPayAmount">
                                            <el-input ref="ipt01" v-model="form.fundPayAmount" placeholder="请输入医保统筹基金支付" maxlength="20"
                                                show-word-limit margin-top:-80px style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="其他支付" prop="otherPayAmount">
                                            <el-input ref="ipt01" v-model="form.otherPayAmount" placeholder="请输入其他支付" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="个人账户支付" prop="accountPayAmount">
                                            <el-input ref="ipt01" v-model="form.accountPayAmount" placeholder="请输入个人账户支付" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:-10px">
                                    <el-col :span="8" style="margin-left:-70px">
                                        <el-form-item label="个人现金支付" prop="ownPayAmount">
                                            <el-input ref="ipt01" v-model="form.ownPayAmount" placeholder="请输入个人现金支付" maxlength="20"
                                                show-word-limit margin-top:-80px style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="个人自付" prop="selfpaymentAmount">
                                            <el-input ref="ipt01" v-model="form.selfpaymentAmount" placeholder="请输入个人自付" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="个人自费" prop="selfpaymentCost">
                                            <el-input ref="ipt01" v-model="form.selfpaymentCost" placeholder="请输入个人账户支付" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:-10px">
                                    <el-col :span="8" style="margin-left:-70px">
                                        <el-form-item label="病例号" prop="caseNumber">
                                            <el-input ref="ipt01" v-model="form.caseNumber" placeholder="请输入病例号" maxlength="20"
                                                show-word-limit margin-top:-80px style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="住院号" prop="hospitalizationNumber">
                                            <el-input ref="ipt01" v-model="form.hospitalizationNumber" placeholder="请输入住院号" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="科别" prop="departmentName">
                                            <el-input ref="ipt01" v-model="form.departmentName" placeholder="请输入科别" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:-10px">
                                    <el-col :span="8" style="margin-left:-70px">
                                        <el-form-item label="住院日期" prop="inHospitalDate">
                                            <el-date-picker placeholder="选择住院日期" v-model="form.inHospitalDate" style="width:200px" 
                                                value-format="yyyy-MM-dd" ></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="出院日期" prop="outHospitalDate">
                                            <el-date-picker placeholder="选择出院日期" v-model="form.outHospitalDate" style="width:200px" 
                                                value-format="yyyy-MM-dd" ></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="预缴金额" prop="prepayAmount">
                                            <el-input ref="ipt01" v-model="form.prepayAmount" placeholder="预缴金额" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:-10px">
                                    <el-col :span="8" style="margin-left:-70px">
                                        <el-form-item label="补缴金额" prop="rechargeAmount">
                                            <el-input ref="ipt01" v-model="form.rechargeAmount" placeholder="请输入补缴金额" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="退费金额" prop="refundAmount">
                                            <el-input ref="ipt01" v-model="form.refundAmount" placeholder="请输入退费金额" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" >
                                        <el-form-item label="性别" prop="gender">
                                            <el-select v-model="form.gender" placeholder="请选择性别" clearable style="width:200px">
                                                <el-option v-for="item in genderOptions" :key="item.value" :label="item.value" :value="item.key" >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:-10px">
                                    <el-col :span="8" style="margin-left:-70px">
                                        <el-form-item label="年龄" prop="age">
                                            <el-input ref="ipt01" v-model="form.age" placeholder="请输入年龄" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" >
                                        <el-form-item label="患者就诊编号" prop="businessNumber">
                                            <el-input ref="ipt01" v-model="form.businessNumber" placeholder="请输入患者就诊编号" maxlength="20"
                                                show-word-limit margin-top:-80px style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <div id="schoolDiv">
                                <el-row style="margin-top:-10px">
                                    <el-col :span="8" style="margin-left:-90px">
                                        <el-form-item label="性别" prop="gender">
                                            <el-select v-model="form.gender" placeholder="请选择性别" clearable style="width:200px">
                                                <el-option v-for="item in genderOptions" :key="item.value" :label="item.value" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="年龄" prop="age">
                                            <el-input ref="ipt01" v-model="form.age" placeholder="请输入年龄" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="地址" prop="address">
                                            <el-input ref="ipt01" v-model="form.address" placeholder="请输入地址" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:-10px">
                                    <el-col :span="8" style="margin-left:-90px">
                                        <el-form-item label="学院" prop="school">
                                            <el-input ref="ipt01" v-model="form.school" placeholder="请输入学院" maxlength="20"
                                                show-word-limit margin-top:-80px style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="院系" prop="faculty">
                                            <el-input ref="ipt01" v-model="form.faculty" placeholder="请输入院系" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="专业" prop="major">
                                            <el-input ref="ipt01" v-model="form.major" placeholder="请输入专业" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:-10px">
                                    <el-col :span="8" style="margin-left:-90px">
                                        <el-form-item label="班级" prop="classes">
                                            <el-input ref="ipt01" v-model="form.classes" placeholder="请输入班级" maxlength="20"
                                                show-word-limit margin-top:-80px style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="学号" prop="studentId">
                                            <el-input ref="ipt01" v-model="form.studentId" placeholder="请输入学号" maxlength="20"
                                                show-word-limit margin-top:-80px  style="width:200px"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                    </el-tab-pane>
                </el-tabs>
            </el-form>
            <div id="hidden-list" ref="hidden-list" class="hidden-list" style="display: none; position: absolute;z-index:999;border: 1px solid #bfbfbf;box-shadow: 0px 0px 2px 0px #aaa;left:10px;">
                <el-table :row-style="{height:'1px'}"  height="320"  stripe border :data="downListTableData" tooltip-effect="light"
                        v-loading="empDownListLoading" style="width: 100%;margin-top: 23px" @row-click="empDownListItemClick">
                    <el-table-column property="displaySeq" type="index" width="50" label="行号"></el-table-column>
                    <el-table-column  width="100" property="auxItemCode"  label='项目编码' ></el-table-column>
                    <el-table-column  width="200" property="auxItemName"  label='项目名称' ></el-table-column>
                    <el-table-column  width="100" property="auxItemUnit"  label='项目单位' ></el-table-column>
                    <el-table-column  width="100" property="auxItemStd"  label='项目标准' ></el-table-column>
                    <el-table-column  width="200" property="auxItemRemark"  label='项目备注' ></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from "lodash"

    let _kits, _form
    export default {
        props: ["entity", "mode"],
        data() {
            var checkPlaceCode = (rule, value, callback) => {
                const reg = /^[0-9]{1,20}$/;
                if (!reg.test(value)) {
                    callback(new Error("开票点代码最长为20位数字"));
                } else {
                    callback();
                }
            };
             var checkEmail = (rule, value, callback) => {
                const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+$/;
                if (value != null && value != "" && !reg.test(value)) {
                    callback(new Error("电子邮箱格式错误"));
                } else {
                    callback();
                }
            };
            var checkMob = (rule, value, callback) => {
                const reg = /^1[3456789]\d{9}$/;
                const reg1 = /^0\d{2,3}-?\d{7,8}$/;
                if (value != null && value != "" && !reg.test(value) && !reg1.test(value)) {
                    callback(new Error("联系电话格式错误"));
                } else {
                    callback();
                }
            };
            let kzxxFlag = true;//扩展信息
            let create = !this.entity.placeCode
            let inputFocusEle
            let form = {
                recordData: [],
                agencyCode: this.entity.agencyCode,
                agencyName: this.entity.agencyName,
                placeCode: this.entity.placeCode,
                payerPartyType: "1",
                payMode:"",
                tel:"",
                email:"",
                payerPartyCode:"",
                einvoiceTypeCode:"",
                businessCode:""
            }
            let data = {
                activeName: 'first',
                empDownListLoading:false,
                downListTableData: [], //展示信息
                einvoiceTypeOptions:[],
                einvoiceJkrlxOptions:[],
                einvoiceSkfsOptions:[],
                genderOptions:[],
                einvoiceTypeCode:"",
                tableHeight:"550",
                tabHeight:"800px",
                showLoading: true,
                showTooltip: false,
                showBtnLoading: false,
                einvtypeCodeOptions: [],
                typeOptions: [],
                create,
                kzxxFlag,
                form,
                formRules: {
                    payerPartyName: [
                        { required: true, message: "请输入交款人", trigger: "blur" }
                    ],
                    payerPartyType: [
                        { required: true, message: "请选择交款人类型", trigger: "blur" }
                    ],
                    payMode: [
                        { required: true, message: "请选择收款方式",  trigger: "blur" }
                    ],
                    tel: [
                        { validator: checkMob, trigger: "blur" }
                    ],
                    email: [
                        { validator: checkEmail, trigger: "blur" }
                    ]
                },
                placeOptions: [],
                supervisorSealOptions: []
            }
            return data
        },
        methods: {
            renderHeader(h, { column, $index }) { // h即为cerateElement的简写，具体可看vue官方文档
                return h(
                    'div',
                    [
                    h('span', column.label),
                    h('i', {
                        class: 'el-icon-circle-plus-outline',
                        style: 'pointer-events: auto; color:#409eff; margin-top:5px; margin-left:8px;width:10px;font-size: 25px;',
                        on: {
                        click: () => { //一定要用箭头函数
                            this.onAdd()
                        }
                        }
                    }, '')
                    ]
                )
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if( index === 6){
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0);
                            // sums[index] += ' 元';
                        }
                    }
                });
                var toatl = sums[6]
                if(toatl != undefined && toatl != null){
                    this.form.totalAmount = toatl.toString();
                }
                return sums;
            },
            //input框失去焦点事件
            handleInputBlur(event){   //当 input 失去焦点 时,input 切换为 span，并且让下方 表格消失（注意，与点击表格事件的执行顺序）
                var _event = event;
                setTimeout(function(){
                    document.getElementById("hidden-list").style.display = "none";
                },200);
            },
            //input获取焦点时讲input元素提出来
            handleInputFocus(event){
                this.inputFocusEle = event.target;
            },
            changeAmount(value){
                var _inputNode = this.inputFocusEle;
                var id = _inputNode.id;
                this.form.recordData[id].auxItemQuantity = value;
                if(isNaN(value)){
                    return;
                }
                // var id = _inputNode.parentElement.parentElement.parentElement.previousElementSibling
                //             .previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.firstElementChild.id;
                this.form.recordData[id].auxItemQuantity = value.replace(/[^\d.]/g,'');
                if(!isNaN(this.form.recordData[id].auxItemQuantity)
                        && !isNaN(this.form.recordData[id].auxItemStd)){
                    this.form.recordData[id].auxItemAmount = this.getFloat(this.floatMul(this.form.recordData[id].auxItemQuantity,this.form.recordData[id].auxItemStd),4).toString();
                    this.form.recordData.push({});
                    this.form.recordData.pop();
                }
            },
            floatMul(a, b) {
                var c = 0,
                    d = a.toString(),
                    e = b.toString();
                try {
                    c += d.split(".")[1].length;
                } catch (f) {}
                try {
                    c += e.split(".")[1].length;
                } catch (f) {}
                return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
            },
            getFloat (num, n) {
                n = n ? parseInt(n) : 0;
                if(n <= 0) {
                    return Math.round(num);
                }
                num = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); //四舍五入
                num = Number(num).toFixed(n); //补足位数
                return num;
            },
            //浮点数除法运算
            floatDiv(arg1,arg2){
                let t1 = 0
                let t2 = 0
                let r1, r2
                try { t1 = arg1.toString().split('.')[1].length } catch (e) { }
                try { t2 = arg2.toString().split('.')[1].length } catch (e) { }
                r1 = Number(arg1.toString().replace('.', ''))
                r2 = Number(arg2.toString().replace('.', ''))
                let intDiv = r1 / r2
                let pow = Math.pow(10, t2 - t1)
                return this.floatMul(intDiv, pow) // 这里用上面定义好的乘法运算
            },
            checkAuxItemAmount(value){
                var _inputNode = this.inputFocusEle;
                var id = _inputNode.id;
                if(!isNaN(value)
                        && !isNaN(this.form.recordData[id].auxItemStd)){
                     var num = this.floatDiv(value, this.form.recordData[id].auxItemStd);
                     var numStr = num.toString().split(".");
                    //  this.form.recordData[id].auxItemQuantity = num;
                     if(numStr.length == 2 && numStr[1].length>8){
                         this.form.recordData[id].auxItemQuantity = parseFloat(this.getFloat(num ,8)).toString();
                     } else {
                         this.form.recordData[id].auxItemQuantity = parseFloat(num).toString();
                     }     
                }
                // var id = _inputNode.parentElement.parentElement.parentElement.previousElementSibling
                //             .previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.firstElementChild.id;
                // this.form.recordData[id].auxItemAmount = value.replace(/[^\d.]/g,'');
                this.form.recordData.push({});
                this.form.recordData.pop();
                // if(!isNaN(this.form.recordData[id].itemQuantity)
                //         && !isNaN(this.form.recordData[id].auxItemStd)){
                //     this.form.recordData[id].auxItemAmount = this.form.recordData[id].itemQuantity*this.form.recordData[id].auxItemStd;
                // }
            },
            //input框编辑时触发的方法，动态弹出员工查询下拉列表
            handleEdit(value) {
                var _inputNode = this.inputFocusEle;
                var top = _inputNode.getBoundingClientRect().top;
                var height = _inputNode.getBoundingClientRect().height;
                this.$refs["hidden-list"].style.left = _inputNode.getBoundingClientRect().left-200+"px";
                this.$refs["hidden-list"].style.top = (top-30+(440-top) + (_inputNode.id * (height+25)))+"px";
                this.$refs["hidden-list"].style.display = "block";
                // _inputNode.parentElement.nextElementSibling.style.display = "block";
                _kits.api.call(
                    "QUERYITEMAUXBYUSER", {itemCodeName: value, einvoiceTypeCode: this.einvoiceTypeCode},
                    result => {
                        if (result.returnCode == "0000") {
                            this.downListTableData = JSON.parse(JSON.stringify(result.data))
                        } else {
                            this.$message.error(result.returnMsg);
                        }
                    }
                );
            },
            //查询下拉的表格行点击事件
            empDownListItemClick(row, event, column){ //
                var _inputNode = this.inputFocusEle;
                var id = _inputNode.id;
                if(row.auxItemCode != ""){
                    this.form.recordData[id].itemCode = row.itemCode;
                    this.form.recordData[id].itemName = row.itemName;
                    this.form.recordData[id].auxItemCode = row.auxItemCode;
                    this.form.recordData[id].auxItemName = row.auxItemName;
                    this.form.recordData[id].auxItemUnit = row.auxItemUnit;
                    this.form.recordData[id].auxItemStd = row.auxItemStd;
                    this.form.recordData[id].key = row.auxItemCode;
                    this.form.recordData.push({});
                    this.form.recordData.pop();
                }
            },
            onAdd() {
                const row = {
                }
                this.form.recordData.push(row)
                if(this.form.recordData.length<8){
                    this.tableHeight=550;
                    this.tabHeight= "800px";
                }else{
                    this.tableHeight=(60*(this.form.recordData.length+2)-(2*(this.form.recordData.length-8))-30);
                    this.tabHeight= 250+this.tableHeight +"px";
                }
            },
            onRemove(row,index) {
                console.log("index",index)
                this.form.recordData.splice(index, 1);
                if(this.form.recordData.length<8){
                    this.tableHeight=550;
                    this.tabHeight= "800px";
                }else{
                    this.tableHeight=(60*(this.form.recordData.length+2)-30);
                    this.tabHeight= 250+this.tableHeight +"px";
                }
            },
            
            handleClick(tab, event) {
                // console.log(tab, event);
            },
            changeType() {
                this.$refs["einvoiceTypeText"].style.display = "none";
                this.$refs["einvoiceTypeSelect"].style.display = "inline";
                document.getElementById("einvoiceTypeSelect").click();
            },
            changeText() {
                this.$refs["einvoiceTypeText"].style.display = "inline";
                this.$refs["einvoiceTypeSelect"].style.display = "none";
                if(this.einvoiceTypeCode  != ""){
                    for(var i=0; i<this.einvoiceTypeOptions.length;i++){
                        if(this.einvoiceTypeOptions[i].einvoiceTypeCode == this.einvoiceTypeCode){
                            if(this.einvoiceTypeOptions[i].einvoiceSortCode=="06"){
                                this.kzxxFlag = true;
                                document.getElementById("schoolDiv").style.display="none";
                                document.getElementById("medicalDiv").style.display="block";
                            }else if(this.einvoiceTypeOptions[i].einvoiceSortCode=="01"){
                                this.kzxxFlag = true;
                                document.getElementById("medicalDiv").style.display="none";
                                document.getElementById("schoolDiv").style.display="block";
                            }else{
                                this.kzxxFlag = false;
                            }
                            this.form.einvoiceTypeCode = this.einvoiceTypeOptions[i].einvoiceTypeCode;
                            this.form.businessCode = this.einvoiceTypeOptions[i].businessCode;
                            this.$refs["einvoiceTypeText"].textContent = this.einvoiceTypeOptions[i].einvoiceTypeName;
                            break;
                        }
                    }
                }
            },
            onBack() {
                this.$emit("back")
            },
            saveEinv() {
                var  data = this.form.recordData;
                if(data.length==0){
                    this.$message.error('请至少输入一行明细')
                    return;
                }
                for(var i=0;i<data.length; i++){
                    if(data[i].itemCode==null || data[i].itemCode=="" || data[i].itemCode == undefined){
                        this.$message.error('第'+(i+1)+'行明细错误')
                        return;
                    }
                    var auxItemQuantityValue = data[i].auxItemQuantity;
                    if(auxItemQuantityValue!=null && auxItemQuantityValue!=""
                            && isNaN(auxItemQuantityValue)){
                        this.$message.error('第'+(i+1)+'行数量格式错误')
                        return;
                    }
                    var reg1 = /^([1-9]\d*|0)(\.\d{1,8})?$/;
                    if (auxItemQuantityValue != null && auxItemQuantityValue != "" && !reg1.test(auxItemQuantityValue)) {
                        this.$message.error('第'+(i+1)+'行数量格式错误')
                        return;
                    }
                    if(data[i].auxItemAmount==null || data[i].auxItemAmount=="" || data[i].auxItemAmount == undefined){
                        this.$message.error('第'+(i+1)+'行金额为空')
                        return;
                    }
                    var reg = /^([1-9]\d{0,13}|0)(\.\d{1,4})?$/;
                    var value = data[i].auxItemAmount;
                    if (value != null && value != "" && !reg.test(value)) {
                        this.$message.error('第'+(i+1)+'行金额格式错误')
                        return;
                    }
                    if(!reg.test(this.form.totalAmount)){
                        this.$message.error('总金额格式错误')
                        return;
                    }
                }
                _form.submit();
            }
        },
        created() {
            _kits = this.$kits()
            this.onAdd();
            _kits.api.call(
                "QUERYEINVOICETYPEBYUSER", {},
                result => {
                    if (result.returnCode == "0000") {
                        console.log(result.data);
                        if(result.data == null || result.data.einvoiceTypeBusinessList ==null 
                                || result.data.einvoiceTypeBusinessList.length == 0){
                             this.$message.error('无可开具的票据类型')
                             this.onBack();
                        }else{
                            this.einvoiceTypeOptions = result.data.einvoiceTypeBusinessList;
                            this.einvoiceJkrlxOptions = result.data.einvoiceJkrlx;
                            this.einvoiceSkfsOptions = result.data.einvoiceSkfs;
                            this.genderOptions = result.data.gender;
                            this.$refs["einvoiceTypeText"].textContent = this.einvoiceTypeOptions[0].einvoiceTypeName;
                            this.einvoiceTypeCode = this.einvoiceTypeOptions[0].einvoiceTypeCode;
                            this.form.einvoiceTypeCode = this.einvoiceTypeOptions[0].einvoiceTypeCode;
                            this.form.businessCode = this.einvoiceTypeOptions[0].businessCode;
                            document.getElementById("schoolDiv").style.display="none";
                            document.getElementById("medicalDiv").style.display="block";
                            if(this.einvoiceSkfsOptions.length > 0){
                                this.form.payMode = this.einvoiceSkfsOptions[0].key;
                            }
                            if(this.einvoiceTypeOptions[0].einvoiceSortCode=="06"){
                                this.kzxxFlag = true;
                                document.getElementById("schoolDiv").style.display="none";
                                document.getElementById("medicalDiv").style.display="block";
                            }else if(this.einvoiceTypeOptions[0].einvoiceSortCode=="01"){
                                this.kzxxFlag = true;
                                document.getElementById("medicalDiv").style.display="none";
                                document.getElementById("schoolDiv").style.display="block";
                            }else{
                                this.kzxxFlag = false;
                            }
                        }
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
        },
        mounted() {
            _form = _kits.control.getStandardForm({
                name: "form",
                api: "SAVEEINV"
            })
            //*
            setTimeout(() => {
                _kits.page.foucus("ipt01")
                this.showLoading = false
                this.showTooltip = true
            }, 300)
        }
    }
</script>
<style scoped>
</style>